import {fiboPfid, fiboAppid} from '@/constants/common';

let fibo = null;

export const fiboInit = (userInfo={})=>{
  try{
    console.log(userInfo);
    fibo = window.fiboSDK;
    fibo.init({
      pfid:fiboPfid,
      appid:fiboAppid,
      userInfo:userInfo
    })
  }catch(e){
    console.debug('fiboSDK error:',e)
    fibo = window.fiboSDK;
    fibo.init({
      pfid:fiboPfid,
      appid:fiboAppid
    })
  }
}

export const fiboClick = (name,content)=>{
  try{
    fibo.btnClick(name,content);
  }catch(e){
    console.debug('fiboSDK error:',e)
  }
}